import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { cleanupModalBody } from "../src/shared/helpers/modal_body_cleanup"

export default class extends Controller {
  static values = {
    autoOpen: { type: Boolean, default: false }
  }

  connect () {
    this.onHidden = this.handleHidden.bind(this)
    this.element.addEventListener("hidden.bs.modal", this.onHidden)

    // Reconnect after the dialog is moved out of a scrolling table. The Bootstrap
    // instance is already in the middle of show(); disposing it would drop the backdrop.
    if (this.element.dataset.modalPortaling === "true") {
      delete this.element.dataset.modalPortaling
      return
    }

    // Once only: a modal put back in a table being reloaded (content_admin_tables restores the portaled ones)
    // reconnects, and reopening it then, detached, would make Bootstrap append it to <body> and leave it open.
    if (this.autoOpenValue) {
      this.autoOpenValue = false

      requestAnimationFrame(() => {
        this.cleanupOrphanedBackdrop()

        requestAnimationFrame(() => {
          if (this.element.isConnected) this.open()
        })
      })
    }
  }

  disconnect () {
    this.element.removeEventListener("hidden.bs.modal", this.onHidden)

    if (this.element.dataset.modalPortaling === "true") return

    const instance = Modal.getInstance(this.element)
    if (instance) instance.dispose()

    cleanupModalBody()
  }

  open () {
    Modal.getOrCreateInstance(this.element).show()
  }

  close () {
    const instance = Modal.getInstance(this.element)

    if (instance) {
      instance.hide()
    } else {
      this.cleanupOrphanedBackdrop()
    }
  }

  handleHidden () {
    this.cleanupOrphanedBackdrop()
  }

  cleanupOrphanedBackdrop () {
    cleanupModalBody()
  }
}
